import JorneyToHomeRuleBody from "views/j2h/JorneyToHomeRuleBody";
import WhosTheBotRuleBody from "views/wtb/WhosTheBotRuleBody";
import RoleDistributorRuleBody from "views/roleDistributor/RoleDistributorRuleBody";
import SingleRoleRouletteRuleBody from "views/singleRoleRoulette/SingleRoleRouletteRuleBody";
import TeamBuilderRuleBody from "views/teamBuilder/TeamBuilderRuleBody";
import LuckyDrawRuleBody from "views/luckyDraw/LuckyDrawRuleBody";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DealerJackRuleBody from "views/dealerjack/DealerJackRuleBody";
import QuizRuleBody from "views/quiz/QuizRuleBody";
import FightSimulatorRuleBody from "views/fightSimulator/FightSimulatorRuleBody";
import "sass/components/RuleModal.scss";

type RuleModalProps = {
  isOpen: boolean;
  recreationId: number;
  inGame: boolean;
};

export type RuleModalBodyProps = {
  page: number;
};

function RuleModal({ isOpen, recreationId, inGame }: RuleModalProps) {
  const { t } = useTranslation();
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setCurrentPage(0); // 페이지 변경 시 첫 페이지로 초기화
    switch (recreationId) {
      case 0: //J2H
        setPages(4);
        break;
      case 1: //WTB
        setPages(3);
        break;
      case 2: //RoleDistributor
        setPages(6);
        break;
      case 3: //SingleRoleRoulette
        setPages(6);
        break;
      case 4: //TeamBuilder
        setPages(2);
        break;
      case 5: //LuckyDraw
        setPages(2);
        break;
      case 6: //Blackjack
        setPages(3);
        break;
      case 7: //Quiz
        setPages(4);
        break;
      case 8: //FightSimulator
        setPages(2);
        break;
      default:
        break;
    }
  }, [recreationId]); // recreationId 변경 시에만 실행

  // Handle page change
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const getBody = () => {
    switch (recreationId) {
      case 0:
        return <JorneyToHomeRuleBody page={currentPage} />;
      case 1:
        return <WhosTheBotRuleBody page={currentPage} />;
      case 2:
        return <RoleDistributorRuleBody page={currentPage} />;
      case 3:
        return <SingleRoleRouletteRuleBody page={currentPage} />;
      case 4:
        return <TeamBuilderRuleBody page={currentPage} />;
      case 5:
        return <LuckyDrawRuleBody page={currentPage} />;
      case 6:
        return <DealerJackRuleBody page={currentPage} />;
      case 7:
        return <QuizRuleBody page={currentPage} />;
      case 8:
        return <FightSimulatorRuleBody page={currentPage} />;
      default:
        return <div />;
    }
  };

  return (
    <div
      className={`rule-modal space-gray-theme ${isOpen ? "open" : ""} ${
        inGame ? "in-game" : "not-in-game"
      } md:bg-blue-950 bg-blue-950/95 md:rounded-lg shadow-xl border border-gray-700 text-gray-300`}
    >
      {/* Header */}
      <div className="rule-modal-header flex justify-between items-center mb-2 bg-blue-950/95 backdrop-blur-sm">
        <div className="rule-modal-title text-lg font-bold">
          {t("howToPlay")}
        </div>
        <div className="pagination-container flex gap-1">
          {[...Array(pages)].map((_, index) => (
            <button
              key={index}
              className={`pagination-button ${
                currentPage === index ? "active" : ""
              } px-1 py-1 !w-8 !h-auto rounded text-base cursor-pointer`}
              onClick={() => handlePageChange(index)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
      {/* Body */}
      <div className="rule-modal-body px-4 pb-4 overflow-y-auto">
        {getBody()}
      </div>
    </div>
  );
}

export default RuleModal;
